import script from "./StaffBarGraph.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffBarGraph.vue?vue&type=script&setup=true&lang=js"

import "./StaffBarGraph.vue?vue&type=style&index=0&id=52b9ea9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b9ea9f"]])

export default __exports__